import React, {useEffect, useState} from "react";
import "./ReconciledReport.css";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from '../operator_home/sidebar/Sidebar'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import details from "../../assets/stock_details.svg";
import details_active from "../../assets/details_active.svg";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";
import ReconciledReportView from "./ReconciledReportView";
import { getErrorToast, getSuccessToast } from "../../toast";
import { useNavigate } from "react-router-dom";
var fileDownload = require("js-file-download");


function ReconciledReport() {
  const [reconciledData, setreconciledData] = useState([]);
  const [legendDisplay, setLegendDisplay] = useState(false);
  const [undoDisabled, setUndoDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const box_id = ReactSession.get("box_id")
  const role = ReactSession.get("role")

  const columns = [
    {
      id: "Sr_no",
      width: "5%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "SR NO",
    },
    {
      id: "Material_name",
      width: "20%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "MEDICINE NAME (Claim)",
    },
    {
      id: "batch_no",
      width: "15%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "BATCH NO (Claim)",
    },
    {
      id: "quantity",
      width: "3rem",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "CLAIMED QUANTITY",
    },
    {
      id: "quantity2",
      width: "3rem",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "SCANNED QUANTITY",
    },
    {
      id: "short",
      width: "3rem",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "SHORT",
    },
    {
      id: "excess",
      width: "3rem",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "EXCESS",
    },
    {
      id: "status",
      width: "6%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "STATUS",
    },
    {
      id: "remark",
      width: "5%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "REMARK",
    },  
    {
      id: "dropdown",
      width: "3%",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
      label: "ACTION",
    }
  ];

  const downloadReport = async () => {
    const partyINFO = await axiosPrivate.get(
      `/data_entry/party-info/${box_id}/`
    );
    axiosPrivate
      .post(`reconcilation/downlaod-reconciliation-report/${box_id}`, reconciledData,{
        responseType: "blob",
      })
      .then((response) => {
        let name = `${partyINFO.data["party_name"]}_${partyINFO.data["party_code"]}_${partyINFO.data["lr_number"]}.xlsx`;
        fileDownload(
          response.data,
          name
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const claimInfo = () => {
    const id = ReactSession.get('box_id')
    axiosPrivate
      .get(`reconcilation/reconcile/${id}`)
      .then((res) => {
        setreconciledData(res.data.data)
      })
      .catch((err) => {
        console.log(err);
      })
  }
  useEffect(() => {
    claimInfo()
  }, []);

  const updateHandler = (event, inner_row_index, object) => {
    const data = object[inner_row_index]
    if(data['quantity'] === '' || data['quantity'] === null || data['quantity']=== undefined){
      getErrorToast('quantity can not be empty'.toUpperCase())
      return
    }
    if(data['quantity'] === '0' || data['quantity'] === 0){
      getErrorToast('quantity can not be Zero'.toUpperCase())
      return
    }
    if(data['quantity'] <= '0' || data['quantity'] <= 0){
      getErrorToast('quantity can not be negative'.toUpperCase())
      return
    }
    if(data['medicine_batch'] === '' || data['medicine_batch'] === null || data['medicine_batch']=== undefined){
      getErrorToast('BATCH NUMBER can not be empty'.toUpperCase())
      return
    }

    axiosPrivate.patch(`reconcilation/reconcile/${ReactSession.get('box_id')}`, data)
    .then((res) => {
      if(res.status === 204){
        getSuccessToast('Record updated successfully.')
        claimInfo()
      }
    })
  }

  const UndoAPI = () => {
    setUndoDisabled(true)
    const data = { 
      status: false
    }
    axiosPrivate.patch(`reconcilation/save-reconciliation/${ReactSession.get('box_id')}/`, data)
    .then((res) => {
      if(res.status === 204){
        getSuccessToast('Reconcilation Undo.')
        navigate('/stockist-report')
      }
    })
    .catch((error) => {
      console.log(error);
      getErrorToast('Something went wrong!')
    })
    .finally(() => {
      setUndoDisabled(false)
    })
  }

  const UploadRecoMankind = () => {
    
  }



  return (
    <div>
      <div className="main-rcreport">
        <Header />
        {role === '2' ? <Sidebar className="sidebar-operator-home" /> : <OtherSidebar className="sidebar-operator-home"/>}
        <div className="outer-rc">
          <div className="cont-head-container claim-order-head-container">
            <div className="cont-head">Reconciliation</div>
            <button className="reconcilation__verification__action flex__item__header" onClick={UndoAPI} disabled={undoDisabled}>
              Reco Undo
            </button>
            <div>
              {legendDisplay && (
                <div className="legend-container">
                  <ul className="legend-ul-list">
                    <li className="legend-list legend-list-sht">Short</li>
                    <li className="legend-list legend-list-ecs">Excess</li>
                    <li className="legend-list legend-list-eq">Equal</li>
                  </ul>
                </div>
              )}

              <button
                onMouseEnter={() => setLegendDisplay(true)}
                onMouseLeave={() => setLegendDisplay(false)}
                style={{
                  cursor: "pointer",
                  border: "none",
                  background: "none",
                }}
              >
                <img
                  src={legendDisplay ? details_active : details}
                  style={{ width: "75%" }}
                />
              </button>
              <br />
            </div>
          </div>
          <div className="report">
            <Paper
              style={{
                overflow: "hidden",
              }}
            >
              <TableContainer
                className="reconciledTable"
                sx={{ maxHeight: "62.2vh" }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          style={{
                            fontSize: "0.75em",
                            padding: "0.4em",
                            textAlign: "center",
                            width: column.width,
                            color: column.color,
                            backgroundColor: "#000000",
                            fontFamily: "Montserrat",
                          }}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {reconciledData.map((ent, idx) => {
                    return(
                    <React.Fragment key={idx}>
                        <ReconciledReportView 
                          updateEvent={updateHandler}
                          ent={ent}
                          id={idx}
                        />
                    </React.Fragment>
                  )})}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
          <div className="bot-div">
            <button
              id="subCsvBtn"
              onClick={downloadReport}
            >
              Download
            </button>
            <button
              style={{marginLeft: '10px'}}
              id="subCsvBtn"
              onClick={UploadRecoMankind}
            >
              Upload Reco
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReconciledReport;